<template>
  <div>
    <v-row
      class=""
    >
      <v-col cols="4" class="py-1">
        <v-section-panel>
          <template v-slot:title> 例文問題 （※複数選択可）</template>
          <template v-slot:content>
            <v-choice-question-checkboxes checkboxList="reibun" />
          </template>
        </v-section-panel>
      </v-col>

      <v-col cols="4" class="py-1">
        <v-section-panel>
          <template v-slot:title> 活用問題 （※複数選択可）</template>
          <template v-slot:content>
            <v-choice-question-checkboxes checkboxList="katsuyo" />
            <v-switch
              v-model="allCheck"
              inset
              color="secondary"
              label="すべてを選択"
            ></v-switch>
          </template>
        </v-section-panel>
      </v-col>

      <v-col cols="4" class="py-1" v-if="showHanigo">
        <v-section-panel>
          <template v-slot:title> 反意語問題 </template>
          <template v-slot:content>
            <v-choice-question-checkboxes checkboxList="hanigo" />
          </template>
        </v-section-panel>
      </v-col>
    </v-row>

    <!-- 区切り線 -->
    <div v-if="useBreak">
      <p class="v-section-panel__break-line"/>
    </div>

  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceQuestionCheckboxes from '@/components/molecules/ChoiceQuestionCheckboxes'
export default {
  components: {
    VSectionPanel,
    VChoiceQuestionCheckboxes,
  },

  data: () => ({
    checkboxList: "",
  }),

  props: {
    useBreak: {
      type: Boolean,
      default: false,
    },
    showHanigo: {
      type: Boolean,
      default: false,
    }
  },


  computed: {
    allCheck: {
      get() {
        return this.$store.state.conditions.katsuyoAllCheck
      },
      set(value) {
        //すべて選択フラグのON/OFF
        this.$store.commit('conditions/setKatsuyoAllCheck', {
          katsuyoAllCheck: value
        })
        //チェック処理用の配列を用意
        let checkIds = []
        if(value) {
          this.$store.state.master.katsuyoIds.forEach(x=>{
            if(!this.$store.state.conditions.checkedArr['katsuyo'].includes(x)) checkIds.push(x)
          })
        }
        this.setKatsuyo(checkIds)
      }
    }
  },

  methods: {
    setKatsuyo(value){
      this.$store.commit('conditions/setCheckList', {
        listName: 'katsuyo',
        value: value
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-section-panel
  &__title
    color rgb(120 112 112 / 1)
    font-weight bold
    margin-bottom 10px

  &__break-line
    margin-top 26px
    margin-bottom 32px
    border-bottom 1px dashed gray
</style>>
